import { __require as r } from '../node_modules/react/jsx-runtime.js';
var i = r();
export { i as j };
